import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const onInput = object(listener, {
  type: input,
  passive,
  task: async element => {
    const min = element.getAttribute('min') ?? 0
    const max = element.getAttribute('max') ?? 100

    const percentValue = (element.value - min) / (max - min) * 100
    element.style.setProperty('--ea_range__value', `${percentValue}%`)
  }
})

export default input => {
  onInput.listen(input)
}
